__turbopack_context__.v({
  "root": "have-no-account-module-scss-module__b4TeUa__root",
  "sign_up": "have-no-account-module-scss-module__b4TeUa__sign_up",
});
